import styled from 'styled-components';

import { NewReleaseNoData } from '../../../../packages/icons';

export const StyledNewReleaseNoData = styled(NewReleaseNoData)`
    display: block;
    width: 100%;
    height: auto;
`;
